import LazyImage from "@/components/LazyImage";

export interface LocationProps {
  title: string;
  description: string;
  nearby: {
    id: string;
    time: string;
    icon: string;
    location: string;
  }[];
  gmaps_link: string;
  gmaps_thumbnail: string;
}

export default function Location(props: LocationProps) {
  return (
    <div className="bg-coffebrown pt-7 xl:pt-14 pb-16 xl:pb-28">
      <div className="grid grid-cols-2 px-10 xl:px-0 w-full xl:max-w-screen-xl mx-auto">
        <div className="col-span-12 xl:col-span-1">
          <h1
            className="text-white xl:text-6xl font-pluto"
            dangerouslySetInnerHTML={{ __html: props.title }}
          ></h1>
          <h2
            className="text-white text-[13px] xl:text-3xl mt-6 xl:leading-10 mr-0"
            dangerouslySetInnerHTML={{ __html: props.description }}
          ></h2>
        </div>

        <div className="col-span-12 xl:col-span-1 grid grid-cols-2 xl:ml-24 mt-5 xl:mt-0 gap-y-8">
          {props.nearby.map((nearby) => {
            return (
              <div
                key={nearby.id}
                className="flex items-center xl:items-start flex-row xl:flex-col"
              >
                <img
                  src={nearby.icon}
                  loading="lazy"
                  alt="map"
                  width={70}
                  height={70}
                  className="w-[1.8rem] xl:w-[4.3rem] h-[1.8rem] xl:h-[4.3rem]"
                />
                <div className="ml-2.5 xl:ml-0 xl:mt-3.5">
                  <p className="text-white font-pluto">
                    <span className="xl:text-3xl">{nearby.time}</span> min
                  </p>
                  <p
                    className="text-white font-medium text-[10px] xl:text-2xl"
                    dangerouslySetInnerHTML={{ __html: nearby.location }}
                  ></p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="relative w-full xl:max-w-screen-lg mx-auto px-10 xl:px-0">
        <LazyImage
          src={props.gmaps_thumbnail}
          loading="lazy"
          alt="map"
          className="w-full h-full 
          xl:max-h-[720px]
          mt-10 xl:mt-20 rounded-[11px] xl:rounded-3xl
          xl:aspect-[1024/610] 
          "
        />
        <div className="absolute -bottom-4 left-1/2 -translate-x-1/2">
          <a href={props.gmaps_link} target="_blank">
            <button className="inline-flex items-center rounded-[4.8rem] bg-gold px-3 xl:px-6 py-1 xl:py-2 cursor-pointer hover:bg-darkgold">
              <img
                src="https://elements-cms-stg.fragmindstudio.com/uploads/Map_Marker_a22f738d3c.png"
                alt="map-marker"
                width={46}
                height={46}
                loading="lazy"
                className="w-4 xl:w-8 h-4 xl:h-8"
              />
              <span className="text-white text-[10px] xl:text-3xl ml-2 font-medium">
                View Google Maps
              </span>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
